<template>
  <div id="content" v-html="html"></div>
</template>

<script>
import SantongHmtl from './santong';

export default {
  name: 'Agreement',
  data() {
    return {
      html: SantongHmtl,
    };
  },
};
</script>

<style scoped>
#content {
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
}
#content >>> p {
  text-align: left !important;
}

#content >>> li,
#content >>> ul {
  text-align: left !important;
}

#content {
  padding: 15px 15px 10px 15px;
  box-sizing: border-box !important;
  text-align: justify !important;
  max-width: 1024px;
}

#iframe {
  background-color: #fff;
  text-align: justify !important;
  padding: 0 !important;
  border: none;
  overflow-x: hidden;
}

iframe:focus {
  outline: none;
}

#content >>> img {
  display: block;
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  padding: 0 !important;
  margin: 0 auto !important;
}

#content >>> * {
  max-width: 100% !important;
  word-break: break-all;
  box-sizing: border-box !important;
}

#content >>> video {
  max-width: 100% !important;
  word-break: break-all;
  pointer-events: all !important;
  box-sizing: border-box !important;
}

#content >>> a {
  text-decoration: none !important;
}

#content >>> ul {
  max-width: 100% !important;
  margin-left: 0 !important;
  list-style-position: initial !important;
  padding: 0 15px !important;
  box-sizing: border-box !important;
}

#content >>> p {
  max-width: 100% !important;
  line-height: 1.75 !important;
  box-sizing: border-box !important;
}

#content >>> li {
  max-width: 100% !important;
  margin: 5px 0 !important;
  box-sizing: border-box !important;
}
</style>
